import { platform } from 'os'
import axios from '../helpers/axios'
import { resolve } from 'path'
import { rejects } from 'assert'


export const updateLanguage = (userId: string | undefined, token:string, language:string) => {
   
        axios
          .post(`/users/updateLanguage`, { userId, language , platform : "web"},
            {headers: {
        Authorization: token,
        accept: 'application/json',
      },}
          )
          .then((response) => {
            return(response.data)
          })
          .catch((error) => {
            console.log(error)
      })
   
}
 

export const verificationEmail = (email: string | undefined) => {
    return new Promise((resolve, reject) => {
        axios
          .post(`/users/forget-pass`, { email : email, platform : "web"})
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
      })
    })
}
 

export const resetPassword = (password: string | undefined, token: string | undefined ) => {
    return new Promise((resolve, reject) => {
        axios
          .post(`/users/reset-pass`, { password : password, platform : 'web'}, {
            headers: {
              token: token,
              accept: 'application/json',
            },
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
      })
    })
}
 

export const updatePassword = 
(userId: string | undefined,
  authorizationToken: string | undefined, 
  oldPassword: string | undefined, 
  password: string | undefined ) => {
    return new Promise((resolve, reject) => {
        axios
          .post(`/users/${userId}/update-pass/?token=${authorizationToken}`,
          {
            oldPassword:oldPassword,
            password:password
          })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
      })
    })
}


export const updateProfilUser = async(
  userId : string |undefined,
  authorizationToken: string | undefined,
  phoneNumber: string | undefined ,
  email: string | undefined,
  street: string | undefined,
  city: string | undefined,
  zipCode:  string | undefined,
  lastName : string | undefined,
  firstName : string | undefined,

) =>
 {
  try{
  // return  new Promise((resolve, reject) => {
    const response = await axios 
    .put(`/users/${userId}`,
    {
      phoneNumber: phoneNumber ,
      email: email,
      street: street,
      city: city,
      zipCode: zipCode,
      lastName: lastName,
      firstName: firstName,
     
    },
    {
      headers: {
        Authorization: authorizationToken,
        accept: 'application/json',
      }
    
    })
    return response.data
  }catch (error){
    console.error("Erreur API:", error)
    return { success: false, error:  "Erreur inconnue" } 
  
  }
    
}

export const usersUpdateAvatar =
 (userId: string | undefined, 
  avatar: number | undefined, 
  token: any | undefined) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/users/updateAvatar`, { userId: userId, avatar: avatar, platform: "web" }, {
        headers: {
          Authorization: token,
          accept: 'application/json',
        }
      })
      
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


export const ProfileRequest = 
(id: string | undefined,
  token: string | undefined) =>
axios
  .get(`users/${id}`, {
    headers: {
      Authorization: token,
      accept: 'application/json',
    },
  })
  .then((response) => {
    return response?.data
  })
  .catch((error) => {
    console.log(error)
})   

export const updateCountry = (id: string | undefined, token: string | undefined, body: any) =>
  axios
    .post(`/users/updateDefaultCountry`, {userId: id, destinationDefaultCountry: body, platform : 'web'}, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})


export const ReferralCodeParinage = (userId: any) =>
  axios
    .post(`/referrals/referral-code`, {userId: userId, platform : "web"}, {
      headers: {
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})


export const GetReferralCode = (userId: string | undefined, token: string | undefined) =>
  axios
    .get(`/referrals/${userId}/code`, {
      headers: {
        Authorization: token,
        Accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })


    export const FindReferralCode = (code: string | undefined) =>
    axios
    .post('/referrals/find-code', {code: code}, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

    // export const VerifSmsCode =()=>
    //   axios 
    // .post('/verify-sms-code', {}, {
    //    headers: {
    //     Accept: 'application/json',
    //   },

    // })
    // .catch((error)=>{
    //   console.log(error)
    // })

    export const GetStateOfUser = (userId: string | undefined) =>
    axios
    .post('/users/stateOfdata', {userId: userId}, {
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

    export const CalculatorDetails = async (userId: any, destinationCountry: any, distributionChannel: string, paymentMode: string) =>{
    try{
      const response = await  axios.post('/users/userDetailsFinancial', {
        
          "userId":userId,
          "destinationCountry":destinationCountry,
          "distributionChannel": distributionChannel,
          "paymentMode": paymentMode
      
      
      })

        return response?.data
      } 
      catch(error){
        
        return null
      }
  }